// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18


export function formatTime() {
	// console.log(time);
	var Y, M, D, h, m, s;
	var date = new Date(); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

	Y = date.getFullYear() + '-';

	M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';

	D = date.getDate() < 10 ? ('0' + date.getDate()) + " " : date.getDate() + ' ';

	// h = date.getHours() + ':';
	h = date.getHours() < 10 ? ('0' + date.getHours()) + ":" : date.getHours() + ':';
	m = date.getMinutes() < 10 ? ('0' + date.getMinutes()) + ":" : date.getMinutes() + ':';
	// m = date.getMinutes() + ':';
	s = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds();
	// s = date.getSeconds();

	return Y + M + D; //时分秒可以根据自己的需求加上

}

export function getCurrentDate() {
    // console.log(time);
    var Y, M, D, h, m, s;
    var date = new Date(); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

    Y = date.getFullYear() + '年';

    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';

    D = date.getDate() < 10 ? ('0' + date.getDate()) + " " : date.getDate() + '日 ';

    // h = date.getHours() + ':';
    h = date.getHours() < 10 ? ('0' + date.getHours()) + ":" : date.getHours() + ':';
    m = date.getMinutes() < 10 ? ('0' + date.getMinutes()) + ":" : date.getMinutes() + ':';
    // m = date.getMinutes() + ':';
    s = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds();
    // s = date.getSeconds();
  
    return Y + M + D ; //时分秒可以根据自己的需求加上
  
  }

export function formatTime1(hm, date) {
	// console.log(time);
	var Y, M, D, h, m, s;
	var date = new Date(date); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

	Y = date.getFullYear() + '-';

	M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';

	D = date.getDate() < 10 ? ('0' + date.getDate()) + " " : date.getDate() + ' ';

	// h = date.getHours() + ':';
	h = date.getHours() < 10 ? ('0' + date.getHours()) + ":" : date.getHours() + ':';
	m = date.getMinutes() < 10 ? ('0' + date.getMinutes()): date.getMinutes();
	// m = date.getMinutes() + ':';
	s = ':00';
	// s = date.getSeconds();
	if (hm == 'hm') {
		return Y + M + D + h + m +s
	}
	return Y + M + D; //时分秒可以根据自己的需求加上

}

export function fillZero(str) {
	var realNum;
	if (str < 10) {
		realNum = '0' + str;
	} else {
		realNum = str;
	}
	return realNum;
}

export function isIdentityId(identityId) {
	var patrn = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;//长度或格式校验
	//地区校验
	var aCity = {
	  11: "北京",
	  12: "天津",
	  13: "河北",
	  14: "山西",
	  15: "内蒙古",
	  21: "辽宁",
	  22: "吉林",
	  23: "黑龙江",
	  31: "上海",
	  32: "江苏",
	  33: "浙江",
	  34: "安徽",
	  35: "福建",
	  36: "江西",
	  37: "山东",
	  41: "河南",
	  42: "湖北",
	  43: "湖南",
	  44: "广东",
	  45: "广西",
	  46: "海南",
	  50: "重庆",
	  51: "四川",
	  52: "贵州",
	  53: "云南",
	  54: "西藏",
	  61: "陕西",
	  62: "甘肃",
	  63: "青海",
	  64: "宁夏",
	  65: "新疆",
	  71: "台湾",
	  81: "香港",
	  82: "澳门",
	  91: "国外"
	};
	// 出生日期验证
	var sBirthday = (
	  identityId.substr(6, 4) +
	  "-" +
	  Number(identityId.substr(10, 2)) +
	  "-" +
	  Number(identityId.substr(12, 2))
	).replace(/-/g, "/"),
	  d = new Date(sBirthday)
	// 身份证号码校验 最后4位  包括最后一位的数字/字母X
	var sum = 0,
	  weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
	  codes = "10X98765432";
	for (var i = 0; i < identityId.length - 1; i++) {
	  sum += identityId[i] * weights[i];
	}
	var last = codes[sum % 11]; //计算出来的最后一位身份证号码
  
	var errorMsg = '';
	if (identityId === '') {
	  errorMsg = "身份证号不能为空"
	} else if (!patrn.exec(identityId)) {
	  errorMsg = "你输入的身份证长度或格式错误"
	} else if (!aCity[parseInt(identityId.substr(0, 2))]) {
	  errorMsg = "你的身份证地区非法"
	} else if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) { errorMsg = "身份证上的出生日期非法" } else if (identityId[identityId.length - 1] != last) {
	  errorMsg = "你输入的身份证号非法"
	}
	return errorMsg;
  }